import { getApiClient } from "@punchup/utils/apiRegistry";
import { logException } from "@punchup/sentry";

/**
 * Mirrors the GetSpecialTokenResponse discriminated union from the token API route.
 * Callers should check `hasAccess` before reading `token`.
 */
export type ViewingTokenResponse =
  | { hasAccess: true; token: string }
  | {
      hasAccess: false;
      checkPaidSubscription: boolean;
      checkPurchase: boolean;
      checkFollow: boolean;
    };

export async function getViewingTokenForSpecial(
  specialId: string
): Promise<ViewingTokenResponse | null> {
  try {
    return await getApiClient()
      .get<{ data: ViewingTokenResponse }>(
        `/api/v2/user/specials/${specialId}/token`
      )
      .then((res) => res.data);
  } catch (err) {
    logException(err, { tags: { specialId } });
    return null;
  }
}

export async function getPublicVideoURL(videoID: string) {
  return `${videoID}`;
}
